<style lang="scss">
    .page-title {
        padding: 30px 40px 10px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;

        }
    }
    .data-box{
        padding:40px 30px;
        a{
            font-size:14px;
            color:#5078e6;
            text-decoration: underline;

        }
        .header{
            font-size:14px;
            color:#697d9b;
            background:#d8d9df;
            font-weight:normal;
            text-align: center;
        }
        .pagination{
            margin-top:10px;
        }

    }

</style>

<template>
    <div>
        <div class="page-title clearfix">
            <h2>支付记录</h2>
        </div>
        <div class="data-box" v-loading="loading">


            <div class="table-box">
                <el-table
                        header-cell-class-name="header"
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            width="90"
                            prop="payBillType"
                            label="支付项目"
                            align="center"
                    >
                        <template slot-scope="scope">
                            {{dictType[scope.row.payBillType]}}
                        </template>

                    </el-table-column>
                    <el-table-column
                            prop="createDate"
                            label="支付时间"
                            align="center"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.createDate | formatDate}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="realAmt"
                            label="支付金额">
                        <template slot-scope="scope">
                            {{ scope.row.realAmt | currency}}
                        </template>

                    </el-table-column>
                    <!--todo 缺字段-->
                    <el-table-column
                            align="center"
                            prop="remark"
                            label="支付详情">
                        <template slot-scope="scope">
                            <div v-if=" scope.row.payBillStatus == '支付成功'"> <p>账户余额支付：{{ scope.row.accountAmt | currency}} </p>
                                <p>实付金额：{{ scope.row.payAmt | currency}} </p>
                            </div>
                            <div v-else>--</div>


                        </template>

                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="payBillStatus"
                            label="状态"
                            width="100"

                    >

                    </el-table-column>

                </el-table>
                <div class="pagination">
                    <el-row>
                        <el-col :span="24"><el-pagination
                                background
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                layout=" prev, pager, next, slot, jumper"
                                :page-count="pageCount"
                                :page-size="pageSize"
                                :total="total">
                           <span class="el-pagination__jump"> 共{{pageCount}}页</span>

                        </el-pagination>
                        </el-col>
                        <el-col :span="3">
                            <!--<el-button size="small" type="primary" @click="">确定</el-button>-->
                        </el-col>
                    </el-row>


                </div>
            </div>

        </div>

        <IsVerified :callback ="getList" ref="verifyCmp" @showLoading = "showLoading" :visible="verifyVisible" />



    </div>
</template>
<script>
	import IsVerified from '../../components/isVerified'

	export default {

		data() {
			return {
				loading:false,
				verifyVisible:false,
                tableData:[],
				currentPage:1,
				total:0,
				pageCount:1,
				pageSize:10,
                dictType:{
					'1':'借款审核',
					'2':'借款审核',
					'3':'身份验证',
					'7':'身份验证',
					'10':'身份验证',
					'4':'还款',
					'5':'还款',
					'6':'还款',
					'13':'还款',
					'8':'投标',
					'9':'充值',
					'11':'购买转让债权',
					'12':'理财计划',
					'14':'小额鉴权',

			    }
			}

		},
		components:{IsVerified},
		methods:{
			showLoading(show){
				this.loading=show

			},
			showVerify(show){
				this.verifyVisible =show
			},
			getList(){
				this.loading=true

				this.$axios({
					method: 'get',
					url: '/user/paybills/list',
					params: {
						offset: this.currentPage,
						limit:this.pageSize
					},
				}).then( (res) =>{
					this.loading=false

					console.log(res)
					this.total=res.data.dataCount
					this.pageCount = res.data.pageCount
					this.tableData = res.data.dataList

				}).catch( (err)=> {
					this.loading=false

					console.warn(err)
					if(err.code = "403"){
						this.$refs.verifyCmp.isVerified();
						return this.showVerify(true)
					}
					this.$alert('系统错误，请稍后再试', '提示', {
						confirmButtonText: '确定',
					});
				})
            },
			handleCurrentChange(page){
				console.log('page:',page)
				this.currentPage=page
				this.getList()
                this.doLog('PC我的借款-支付记录-翻页')

			},

        },
        mounted(){
			this.getList()
            this.doLog('PC我的借款-支付记录PV','visit')

        }
	}
</script>